// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
//import "channels"
//import "controllers"
import "custom";
import "chartkick/chart.js"


Rails.start()
ActiveStorage.start()

// Import custom modules for dynamic functionality
require("stylesheets/application.scss")

// This is to import media files
function importAll(r) {
    r.keys().forEach(r);
}

// Import all images including subfolders
importAll(require.context('../images/', true, /\.(svg|jpg|png|ico)$/));

require("../custom/temporary_audio_uploader")
require("../custom/temporary_cover_art_uploader")
require("../custom/flatpickr")
require("../custom/payment")
require("../custom/chart")
require("../custom/dashboard_analytics")
require("../custom/user_onboarding")

document.addEventListener("turbo:load", function () {
    // Rewardful is loaded async from r.wdfl.co and is only present in layouts
    // that include the Rewardful <script> tag (currently application.html.erb).
    // Guard against the race (script not yet loaded) and the scope mismatch
    // (layouts that don't load the tag at all).
    if (typeof window.Rewardful === "undefined" || !window.Rewardful.Forms) {
        return;
    }
    window.Rewardful.Forms.attach();
});

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}
